// Handle SVG LazyLoading
window.addEventListener("load", function() {
    const svgContainers = document.querySelectorAll(".svg-container");

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Load SVG when it enters the viewport
                loadSVG(entry.target);
                observer.unobserve(entry.target);
            }
        });
    });

    svgContainers.forEach(container => {
        observer.observe(container);
    });

    const promiseCache = {}; // Cache for storing loaded SVG promises

    function loadSVG(container) {
        const svgSrc = container.getAttribute("data-src");
        const classList = Array.from(container.classList).filter(className => className !== "svg-container"); // Remove "svg-container" class
        const attributes = Array.from(container.attributes).filter(attr => attr.name !== "data-src" && attr.name !== "class"); // Filter out 'data-src' and 'class'

        // Check if SVG content is already cached
        if (promiseCache[svgSrc]) {
            promiseCache[svgSrc].then(svgContent => {
                if (svgContent) {
                    const svgElement = svgContent.cloneNode(true);
                    setAttributesAndClasses(svgElement, classList, attributes);
                    container.replaceWith(svgElement); // Replace the container with the cached SVG
                    handleSvgScripts(svgElement);
                }
            });

            return;
        }

        // If not cached, fetch SVG content
        const fetchPromise = fetch(svgSrc)
            .then(response => {
                if (response.ok) {
                    return response.text();
                }
                throw new Error(`Failed to load SVG`);
            })
            .then(svgText => {
                const svgElement = new DOMParser().parseFromString(svgText, "image/svg+xml").documentElement;
                return svgElement;
            })
            .catch(error => {
                return null;
            });

        // Cache the fetch promise
        promiseCache[svgSrc] = fetchPromise;

        // Once SVG content is loaded, replace the container
        fetchPromise.then(svgElement => {
            if (svgElement) {
                setAttributesAndClasses(svgElement, classList, attributes);
                container.replaceWith(svgElement); // Replace the container with the loaded SVG
                handleSvgScripts(svgElement);
            }
        });
    }

    // Function to set classes and attributes
    function setAttributesAndClasses(svgElement, classList, attributes) {
        // Start with provided classes + user-svg
        let finalClasses = [...classList, "user-svg"];

        // Also include any existing classes on the element
        const existing = svgElement.getAttribute("class");
        if (existing) {
            finalClasses.push(...existing.split(/\s+/));
        }

        // Deduplicate + set
        finalClasses = [...new Set(finalClasses)];
        svgElement.setAttribute("class", finalClasses.join(" "));

        // Apply other attributes
        attributes.forEach(attr => {
            svgElement.setAttribute(attr.name, attr.value);
        });
    }

    // Function to handle SVG scripts (if any)
    function handleSvgScripts(svgElement) {
        const scriptElement = svgElement.querySelector('script');

        if (scriptElement) {
            const newScript = document.createElement('script');
            newScript.type = 'text/javascript';

            if (scriptElement.textContent.startsWith('<![CDATA[') && scriptElement.textContent.endsWith(']]>')) {
                newScript.textContent = scriptElement.textContent.slice(9, -3);
            } else {
                newScript.textContent = scriptElement.textContent;
            }

            document.head.appendChild(newScript);
            document.head.removeChild(newScript);
        }
    }
});
